// Types
export type {
  ThemeName,
  ThemeMode,
  ThemeConfig,
  ColorScheme,
  ExtendedColors,
  TypographyScale,
  TypographySystem,
} from './types/theme.types.js';

// Constants
export {
  THEME_STORAGE_KEY,
  THEME_CLASS_MAP,
  THEME_CONFIGS,
  DEFAULT_THEME,
  THEME_NAMES,
  THEME_LABELS,
} from './constants/theme.constants.js';

// MUI Theme
export { muiTheme } from './theme/mui-theme.js';

// Components
export * from './components/index.js';
